import React, { useEffect, useState } from "react";
import "./Wallet.css";
import { useAccount, useWalletClient } from "wagmi";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { toast } from "react-toastify";


import { collection, doc, getDoc, getDocs, query, setDoc, where } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth, firestoredb } from "../../../firebase/firebase";


function Wallet() {
  const { address } = useAccount();
  const [BindedWallet, setBindedWallet] = useState("");
  // const test = useSignMessage();
  const [userisLogged, setUserisLogged] = useState();
  const [alreadyBinded, setAlreadyBinded] = useState();

  const { data: signer, isError } = useWalletClient();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate()
  const bindWalletWithUser = async () => {
    if (isLoading) {
      toast.warning("Please Wait!", { toastId: "pleaseWait" });
    } else {
      setIsLoading(true);

      try {
        const res = await signer.signMessage({
          address,
          message: "Are you sure you want to bind the wallet with this user?",
        });

        if (res) {


          const q = query(collection(firestoredb, "Users"), where("bindedWallet", "==", address));
          const querySnapshot = await getDocs(q);
          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
          });

          const userInfoRef = doc(firestoredb, "Users", userisLogged.uid);

          setDoc(userInfoRef, { bindedWallet: address }, { merge: true })
            .then(() => {
              toast.success("Wallet Binded with user", {
                toastId: "signSuccess",
              });
              setIsLoading(false);
              window.location.reload(false);
            })
            .catch((err) => {
              setIsLoading(false);
              toast.error("Something went wrong!", { toastId: "signError" });
              console.log(err);
            });
        }
      } catch (err) {
        console.log(err);
        setIsLoading(false);
        toast.error("User Rejected Signing", { toastId: "signError" });
      }
    }
  };

  const unbindWalletWithUser = async () => {
    if (isLoading) {
      toast.warning("Please Wait!", { toastId: "pleaseWait" });
    } else {
      setIsLoading(true);

      try {
        const res = await signer.signMessage({
          address,
          message: "Are you sure you want to bind the wallet with this user?",
        });

        if (res) {
          const userInfoRef = doc(firestoredb, "Users", userisLogged.uid);

          setDoc(userInfoRef, { bindedWallet: "" }, { merge: true })
            .then(() => {
              toast.success("Wallet unbinded successfully!", {
                toastId: "signSuccess",
              });
              setIsLoading(false);
              window.location.reload(false);
            })
            .catch((err) => {
              setIsLoading(false);
              toast.error("Something went wrong!", { toastId: "signError" });
              console.log(err);
            });
        }
      } catch (err) {
        console.log(err);
        setIsLoading(false);
        toast.error("User Rejected Signing", { toastId: "signError" });
      }
    }
  };


  const getUserInfo = async () => {
    if (userisLogged) {
      if (address) {
        const q = query(collection(firestoredb, "Users"), where("bindedWallet", "==", address));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          setAlreadyBinded({ [doc.id]: doc.data().bindedWallet })
        });
      }
      const userInfoRef = doc(firestoredb, "Users", userisLogged.uid);
      await getDoc(userInfoRef)
        .then((res) => {
          setBindedWallet({ bindedWallet: res.data()?.bindedWallet, bindedEmail: res.data()?.email });
        })
        .catch((err) => {
          console.log(err);
        });

    }
  };

  useEffect(() => {
    getUserInfo();
  }, [userisLogged, address]);


  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in.
        const uid = user.uid;

        setUserisLogged(user);
      } else {
        // User is signed out.

        setUserisLogged(user);
        navigate("/login")

      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <div>
      <div className="wallet">
        <div className="input-box connect-wallet">
          <p className="wallet-para">Connected Wallet</p>
          {
            address ?
              <>
                <div className="input-box-1 d-flex align-items-center">
                  <p className="mb-0 body-large text-light-grey">
                    <img
                      src="\assets\images\Account-setting\MetaMask.svg"
                      alt="Metamask"
                      className="me-2"
                    />
                    Metamask
                    <span className="ms-5 text-white">{BindedWallet.bindedWallet == "" ? address : `Binded with ${BindedWallet.bindedWallet}`}</span>
                  </p>
                  <div className="unbind-btn">

                    {
                      alreadyBinded ? alreadyBinded[userisLogged.uid] == address ?
                        <button onClick={unbindWalletWithUser}>UnBind</button> :
                        <></>
                        :
                        BindedWallet.bindedWallet == address ?
                          <button onClick={unbindWalletWithUser}>UnBind</button> :
                          BindedWallet.bindedWallet == "" ?
                            <button onClick={bindWalletWithUser}>Bind</button> : <></>}
                  </div>
                </div>
              </> :
              <ConnectButton />
          }


        </div>
      </div>
    </div>
  );
}

export default Wallet;
